<template>
  <component :is="!parent.isMobile ? DropdownMenuSub : DrawerRootNested">
    <component
      :is="!parent.isMobile ? DropdownMenuSubTrigger : DrawerTrigger"
      as-child
    >
      <button
        type="button"
        :disabled="props.disabled"
        :class="[
          'group/item',
          'relative flex shrink-0 cursor-pointer select-none items-center gap-3 self-stretch rounded-md border-none px-3 outline-none transition-colors duration-75',
          'text-left text-sm text-current',
          !parent.isMobile ? 'py-1' : 'py-2',
          props.disabled && 'pointer-events-none cursor-not-allowed opacity-50',
          `hover:bg-dark-muted focus-visible:bg-dark-muted data-[state=open]:bg-dark-muted dark:hover:bg-muted dark:focus-visible:bg-muted dark:data-[state=open]:bg-muted`,
        ]"
      >
        <slot v-if="slots.icon" name="icon" />
        <component
          :is="iconMappingMicro[props.icon]"
          v-else-if="props.icon"
          class="size-4 shrink-0 text-muted-foreground"
        />

        <span class="min-w-0 grow truncate break-words">
          {{ props.label }}
        </span>

        <ChevronDownIcon
          class="-mr-1 size-4 shrink-0 -rotate-90 text-muted-foreground"
        />
      </button>
    </component>

    <Container>
      <slot></slot>
    </Container>
  </component>
</template>

<script setup lang="ts">
import { DropdownMenuSub, DropdownMenuSubTrigger } from "reka-ui";
import { DrawerRootNested, DrawerTrigger } from "vaul-vue";

import ChevronDownIcon from "@/icons/heroicons/chevron-down-micro.svg";
import {
  type MappedIconMicro,
  iconMappingMicro,
} from "@/icons/icon-mapping-micro";

import Container from "./Container.vue";
import { inject, provide } from "./context";

const parent = inject();

const props = defineProps<{
  icon?: MappedIconMicro;
  label?: string;
  disabled?: boolean;
}>();

const slots = defineSlots<{
  icon?(): unknown;
  default?(): unknown;
}>();

provide({
  id: undefined,
  isNested: true,
  get isMobile() {
    return parent.isMobile;
  },

  triggerElement: undefined,
});
</script>
